import React from 'react';
import PropTypes from 'prop-types';
import {intlShape, injectIntl} from 'react-intl';
import {Helmet} from 'react-helmet';
import config from '../config';
import {APPS_PER_PAGE} from '../services/market-api';
import {getAlternateLanguages} from '../services/utils';
import injectMain from '../services/inject-main';

class LayoutMeta extends React.Component {
  render() {
    const formatMessage = this.props.intl.formatMessage;
    const url = this.props.fullUrl + this.props.location.pathname;
    const altLang = getAlternateLanguages(url);

    return (
      <Helmet>
        <title>{formatMessage({id: 'home.meta.title'})}</title>
        <meta name="description" content={formatMessage({id: 'home.meta.description'})}/>
        <meta name="twitter:creator:id" content={formatMessage({id: 'home.meta.twitter.accountId'})}/>
        <meta name="twitter:card" content="summary_large_image"/>
        <meta name="twitter:site" content={formatMessage({id: 'home.meta.twitter.site'})}/>
        <meta property="fb:app_id" content={formatMessage({id: 'home.meta.facebook.appId'})}/>
        <meta property="og:type" content="website"/>
        <meta property="og:site_name" content="WIX.com"/>
        <meta property="og:url" content={url}/>
        <meta property="og:title" content={formatMessage({id: 'home.meta.title'})}/>
        <meta property="og:description" content={formatMessage({id: 'home.meta.description'})}/>
        <meta property="og:image" content={`https:${config.topology.baseStaticUrl}images/share-app-market.jpg`}/>
        <meta httpEquiv="content-language" content={this.props.lang}/>
        <link rel="canonical" href={url}/>
        {altLang.map((i) =>
          <link key={i.lang} rel="alternate" hreflang={i.lang} href={i.url}/> // eslint-disable-line
        )}
      </Helmet>
    );
  }

  static propTypes = {
    intl: intlShape,
    location: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    fullUrl: PropTypes.string
  }
}

export const LayoutMetadata = injectMain(injectIntl(LayoutMeta));


class CategoryMeta extends React.Component {
  render() {
    const formatMessage = this.props.intl.formatMessage;
    const url = this.props.fullUrl + this.props.location.pathname;
    const page = Number(this.props.location.query.page) || 1;
    const prevPage = page > 1 ? page - 1 : undefined;
    const nextPage = this.props.appCount === APPS_PER_PAGE ? page + 1 : undefined;

    return (
      <Helmet>
        <title>{formatMessage({id: 'category.meta.title'}, {categoryName: this.props.title})}</title>
        <meta name="description" content={this.props.description}/>
        <meta property="og:title" content={formatMessage({id: 'category.meta.title'}, {categoryName: this.props.title})}/>
        <meta property="og:description" content={this.props.description}/>
        {prevPage ? <link rel="prev" href={`${url}?page=${prevPage}`}/> : null }
        {nextPage ? <link rel="next" href={`${url}?page=${nextPage}`}/> : null }
      </Helmet>
    );
  }

  static propTypes = {
    intl: intlShape,
    title: PropTypes.string,
    description: PropTypes.string,
    location: PropTypes.object,
    appCount: PropTypes.number,
    fullUrl: PropTypes.string
  }
}

export const CategoryMetadata = injectMain(injectIntl(CategoryMeta));


class AppMeta extends React.Component {
  render() {
    const formatMessage = this.props.intl.formatMessage;

    return (
      <Helmet>
        <title>{formatMessage({id: 'application.title'}, {app: this.props.title})}</title>
        <meta name="description" content={this.props.description}/>
        <meta property="og:title" content={formatMessage({id: 'application.title'}, {app: this.props.title})}/>
        <meta property="og:description" content={this.props.description}/>
        <meta property="og:image" content={`https://dev.wix.com/share-image/${this.props.id}`}/>
      </Helmet>
    );
  }

  static propTypes = {
    intl: intlShape,
    title: PropTypes.string,
    description: PropTypes.string,
    id: PropTypes.string
  }
}

export const AppMetadata = injectIntl(AppMeta);



// WEBPACK FOOTER //
// ./components/Metadata.js